module.exports = __webpack_public_path__ + "fonts/S1VWcNub.woff2";